import React, { useEffect, useState } from "react";
import { Form, Input, Button, Checkbox } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import "antd/dist/reset.css"; // or 'antd/dist/antd.less'
import "./SignIn.css";
import { useDispatch } from "react-redux";
import { useHistory, Link } from "react-router-dom";
// import ReactLoading from "react-loading";
import liracrypt from "../Liracrypt/liracrypt";
import { useParams, useLocation } from "react-router-dom";
import queryString from "query-string";

function SignInSparsh() {
  const { search } = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { urlCode } = useParams();
  const searchParams = queryString.parse(search);
  const [isInvalid, setInvalid] = useState(false);
  const [ErrorText, setErrorText] = useState("Invalid Login Credentials !");
  const [ShowLoadingLogin, setShowLoadingLogin] = useState(false);

  const onFinish = (values) => {
    setShowLoadingLogin(true);
    const { username, password } = values;
    liracrypt.login(
      {
        username,
        password,
        urlCode,
        scode: process.env.REACT_APP_CODE,
        sparsh: searchParams.token,
        ...searchParams
      },
      dispatch,
      history,
      setShowLoadingLogin,
      setInvalid,
      setErrorText
    );
  };

  useEffect(() => {
    onFinish({ username: 'abc', password: 'abc' });
  }, []);

  function Invalid() {
    if (isInvalid) {
      return (
        <div style={{ textAlign: "center" }}>
          <div
            className="mx-auto invalidator"
            style={{
              margin: "1rem",
              backgroundColor: "#ff3d41",
              borderRadius: "10px",
              padding: ".4rem",
              color: "#fff",
              fontWeight: "600",
              minWidth: "92%",
            }}
          >
            <span style={{ float: "left", marginLeft: "10px" }}>&#9888;</span>
            <span style={{ marginTop: "3.5px" }}>{ErrorText}</span>
            <a
              style={{ float: "right", marginRight: "2px", color: "#fff" }}
              onClick={() => setInvalid(false)}
            >
              &times;
            </a>
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  }

  return (
    <>
      <div
        className=""
        style={{
          minHeight: "100%",
          backgroundColor: "#262626"
        }}
      >
        <div
          className="row align-items-center "
        >
          <div>
            <div className="row justify-content-center">
              <div
                className=" col-10 col-sm-10 col-md-6 col-lg-4"
                style={{
                  boxShadow: "0px 0px 10px 0px black",
                  borderRadius: "15px",
                  backgroundColor: "#1d1d1d",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100vw",

                  height: "100vh",
                }}
              >
                <img
                  alt="Df"
                  src={require('../../assets/static/Df.png')}
                  // src={require("../../images/Tracost.jpeg")}
                  width="300px"
                  style={{ margin: "1rem", marginBottom: 0, padding: "1rem" }}
                />
                <h2
                  style={{
                    padding: ".8rem",
                    paddingBottom: "0",
                    fontWeight: "500",
                    color: "#fff",
                    textAlign: "center",
                    fontSize: "2rem",
                  }}
                >
                  Sign In
                </h2>
                <Form
                  name="normal_login"
                  className="login-form"
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                  style={{ textAlign: "center", minWidth: "360px" }}
                >
                  <div style={{ marginBottom: ".5rem" }}>
                    <Form.Item
                      name="username"
                      style={{
                        fontWeight: "600",
                      }}
                      rules={[
                        {
                          required: true,
                          message: (
                            <span style={{ marginLeft: "1rem" }}>
                              Please input your Username!
                            </span>
                          ),
                        },
                      ]}
                    >
                      <Input
                        style={{
                          maxWidth: "90%",
                        }}
                        prefix={
                          <UserOutlined className="site-form-item-icon" />
                        }
                        placeholder="Username"
                      />
                    </Form.Item>
                  </div>
                  <div style={{ marginBottom: "1rem" }}>
                    <Form.Item
                      name="password"
                      style={{ fontWeight: "600" }}
                      rules={[
                        {
                          required: true,
                          message: (
                            <span style={{ marginLeft: "1rem" }}>
                              Please input your Password!
                            </span>
                          ),
                        },
                      ]}
                    >
                      <Input
                        style={{
                          maxWidth: "90%",
                        }}
                        prefix={
                          <LockOutlined className="site-form-item-icon" />
                        }
                        type="password"
                        placeholder="Password"
                      />
                    </Form.Item>
                  </div>
                  {/* <Form.Item
                    style={{
                      textAlign: "right",
                      marginRight: "20px",
                    }}
                  >
                    <Form.Item name="remember" valuePropName="checked" noStyle>
                      <Checkbox
                        className="float-left"
                        style={{
                          marginLeft: "1.4rem",
                          color: "#fff",
                          fontWeight: "600",
                        }}
                      >
                        Remember me
                      </Checkbox>
                    </Form.Item>
                  </Form.Item> */}

                  <Invalid />

                  <Form.Item>
                    {/* <Button
                      type="primary"
                      htmlType="submit"
                      className="login-form-button"
                      style={{ borderRadius: "15px", fontWeight: "600" }}
                    >
                      Log in
                    </Button> */}
                    {ShowLoadingLogin ? (
                      <div
                        style={{
                          display: "inline-block",
                        }}
                      >
                        {/* <ReactLoading
                          type="bubbles"
                          color="#007bff"
                          height={20}
                          width={70}
                        /> */}
                      </div>
                    ) : (
                      <div style={{ marginLeft: "25px", marginRight: "10px" }}>
                        <Button
                          size="large"
                          type="primary"
                          htmlType="submit"
                          className="login-form-button"
                          style={{
                            minWidth: "60%",
                            fontWeight: "600",
                            borderRadius: "20px",
                            margin: "1.2rem",
                            marginLeft: 0,
                          }}
                        >
                          Log in
                        </Button>
                      </div>
                    )}
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SignInSparsh;
